import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createContactAndSupport,
  deleteContactAndSupport,
  updateContactAndSupport
} from 'api/companies';
import { companyKeys } from 'api/queryKeys';
import {
  IContactAndSupportCreateRequest,
  IContactAndSupportUpdateRequest
} from 'types/company';

export const useContactAndSupportsMutations = (companyId: string) => {
  const queryClient = useQueryClient();

  const invalidateList = () =>
    queryClient.invalidateQueries({
      queryKey: companyKeys.contactAndSupports(companyId)
    });

  const createMutation = useMutation({
    mutationFn: (body: IContactAndSupportCreateRequest) =>
      createContactAndSupport(companyId, body),
    onSuccess: invalidateList
  });

  const updateMutation = useMutation({
    mutationFn: ({
      id,
      body
    }: {
      id: number;
      body: IContactAndSupportUpdateRequest;
    }) => updateContactAndSupport(companyId, id, body),
    onSuccess: invalidateList
  });

  const deleteMutation = useMutation({
    mutationFn: (id: number) => deleteContactAndSupport(companyId, id),
    onSuccess: invalidateList
  });

  return { createMutation, updateMutation, deleteMutation };
};
